import $ from 'jquery';
$(function () {
  var $modals = $('.modal--video');
  setTimeout(function () {
    return $modals.each(initModal);
  }, 600);
  function initModal(index, modal) {
    var $modal = $(modal);
    var $modalContent = $modal.find('.modal-content');
    var $player = $modal.find('.video-player');
    var $transcript = $modal.find('.video-transcript');
    resizeModal($modalContent, $player, $transcript);
  }
  function resizeModal($modalContent, $player, $transcript) {
    var contentHeight = $modalContent.height();
    var playerHeight = $player.height();
    var transcriptHeight = contentHeight - playerHeight;
    $transcript.css({
      height: transcriptHeight + 'px'
    });
  }
});